import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';
import withImage from '../../../../shared/components/utils/hoc/withImage';

const DetailAddonChannelLogo = styled.img<React.CSSProperties>`
  width: ${Screen.widthRatio * 103}px;
  height: ${Screen.widthRatio * 100}px;
  margin: 0px ${Screen.widthRatio * 10}px ${Screen.widthRatio * 0}px
    ${Screen.widthRatio * 10}px;
`;

export default withImage(DetailAddonChannelLogo);
